import { TreatmentAnalysis } from '../translations-types';

const translations: TreatmentAnalysis = {
  title: 'Behandelanalyse',
  description:
    'Analyseer de behandelingen van een cliënt over een periode en genereer een overzicht van welk type jaarplan de cliënt dit jaar heeft genoten.',
  selectCustomer: 'Cliënt',
  customerPlaceholder: 'Kies een cliënt',
  period: 'Periode',
  generate: 'Genereer analyse',
  generating: 'Bezig met analyseren…',
  resultTitle: 'Analyse',
  empty: 'Kies een cliënt en een periode en genereer de analyse.',
  analyse: 'Analyseer',
  confirmTitle: 'Analyse starten',
  confirmContent: 'cliënt(en) worden geanalyseerd (1 credit per cliënt). Doorgaan?',
  analyseDone: 'Analyse voltooid',
  failuresTitle: 'Niet gelukt voor deze cliënten',
  lastAnalysis: 'Laatste analyse',
  noAnalysis: 'Nog geen analyse',
  historyButton: 'Behandelingen & diensten',
  kindAppointment: 'Afspraak',
  kindService: 'Dienst',
  colDate: 'Datum',
  colType: 'Type',
  colTreatment: 'Behandeling',
  colEmployee: 'Medewerker',
  historyEmpty: 'Geen afspraken of diensten in deze periode',
};

export default translations;
